/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const BannerContainer = styled.div`
  padding: 0 ${token('space.600')} ${token('space.200')};
  margin-top: ${token('space.300')};
  max-width: 536px;
  border-radius: ${borderRadius()}px;
  position: relative;
  box-shadow: ${token(
    'elevation.shadow.overlay',
    `0 4px 8px -2px ${colors.N50A}, 0 0 1px ${colors.N60A}`
  )};
  .close-button {
    position: absolute;
    right: ${token('space.200')};
    top: ${token('space.100')};
  }

  & > span {
    &:first-child {
      position: absolute;
      top: ${token('space.150')};
      left: ${token('space.200')};
    }
  }
`;

export const Title = styled.h4`
  display: inline-block;
  font: ${token('font.heading.xsmall')};
  margin-top: ${token('space.200')};
`;

export const Description = styled.div`
  padding: ${token('space.200')} 0;
`;
